export const MORTGAGE_BANKS = [
  { name: "Bluestep", slug: "bluestep", aliases: ["Bluestep"] },
  { name: "Danske Bank", slug: "danske-bank", aliases: ["Danske Bank"] },
  { name: "Handelsbanken", slug: "handelsbanken", aliases: ["Handelsbanken"] },
  { name: "Hypoteket", slug: "hypoteket", aliases: ["Hypoteket"] },
  { name: "ICA Banken", slug: "ica-banken", aliases: ["ICA Banken"] },
  { name: "Ikano Bank", slug: "ikano-bank", aliases: ["Ikano Bank", "IKANO Bank"] },
  { name: "JAK Medlemsbank", slug: "jak-medlemsbank", aliases: ["JAK Medlemsbank"] },
  { name: "Landshypotek", slug: "landshypotek", aliases: ["Landshypotek"] },
  { name: "Länsförsäkringar", slug: "lansforsakringar", aliases: ["Länsförsäkringar"] },
  { name: "Nordea", slug: "nordea", aliases: ["Nordea"] },
  { name: "SBAB", slug: "sbab", aliases: ["SBAB"] },
  { name: "SEB", slug: "seb", aliases: ["SEB"] },
  { name: "Skandia", slug: "skandia", aliases: ["Skandia"] },
  { name: "Stabelo", slug: "stabelo", aliases: ["Stabelo"] },
  { name: "Swedbank", slug: "swedbank", aliases: ["Swedbank"] },
  { name: "Ålandsbanken", slug: "alandsbanken", aliases: ["Ålandsbanken"] },
] as const;

export type MortgageBank = (typeof MORTGAGE_BANKS)[number];
export type MortgageBankName = MortgageBank["name"];

const BANKS_BY_ALIAS = new Map(
  MORTGAGE_BANKS.flatMap((bank) => bank.aliases.map((alias) => [alias, bank] as const))
);

const BANKS_BY_NAME = new Map(MORTGAGE_BANKS.map((bank) => [bank.name, bank] as const));

function slugifyMortgageBankName(name: string): string {
  return name
    .toLowerCase()
    .replace(/å/g, "a")
    .replace(/ä/g, "a")
    .replace(/ö/g, "o")
    .replace(/\s+/g, "-");
}

export function canonicalizeMortgageBankName(name: string): MortgageBankName | string {
  return BANKS_BY_ALIAS.get(name)?.name || name;
}

export function getMortgageBankSlug(name: string): string {
  return BANKS_BY_ALIAS.get(name)?.slug || BANKS_BY_NAME.get(name as MortgageBankName)?.slug || slugifyMortgageBankName(name);
}

export function getMortgageBankAliases(name: string): readonly string[] {
  return BANKS_BY_ALIAS.get(name)?.aliases || BANKS_BY_NAME.get(name as MortgageBankName)?.aliases || [name];
}
